// 获取今天的日期
export function getNowFormatDate () {
  var date = new Date();
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

// 保存量表所有题目
/**
 * {
    gaugeId: {
      version: "",
      questions: []
    }
  }
 * 
 */
// {
//   userId: {
//     tsakId: {
//       gaugeId+verision: {
//          recordList: [],
//          recordTime:0
//       }
//     },
//     gaugeId + verision: []
//   }
// }
//保存量表答题记录---一题一题保存   type: 1 存答题记录，2存结束语心情选项
export function saveGaugeEvaluationRecord (userId, gaugeId, data, type) {
  let recordData // 查询是否有保存记录

  recordData = window.localStorage.getItem(userId + "record")
  if (!recordData) {
    recordData = {}
  } else {
    recordData = JSON.parse(recordData)
  }
  if (recordData[gaugeId]) {
    if (type === 1) {
      recordData[gaugeId].recordList.push(data)
    } else {
      recordData[gaugeId].recordTime = data
    }
  } else {
    recordData[gaugeId] = {
      recordList: [],
      recordTime: 0
    }
    if (type === 1) {
      recordData[gaugeId].recordList.push(data)
    } else {
      recordData[gaugeId].recordTime = data
    }
  }

  window.localStorage.setItem(userId + "record", JSON.stringify(recordData))
}

// 保存已完成量表的答题记录
export function saveGaugeEvaluationRecordAll (userId, gaugeId, data, taskId) {
  let recordData // 查询是否有保存记录

  recordData = window.localStorage.getItem(userId + "record")
  if (!recordData) {
    recordData = {}
  } else {
    recordData = JSON.parse(recordData)
  }
  if (taskId) { // 任务测评
    if (recordData[taskId]) { // 任务有保存过
      recordData[taskId][gaugeId] = {}
      recordData[taskId][gaugeId].recordList = data
    } else { // 任务没有保存过
      recordData[taskId] = {}
      recordData[taskId][gaugeId] = {}
      recordData[taskId][gaugeId].recordList = data
    }
  } else { // 普通量表测评
    recordData[gaugeId] = data
  }

  window.localStorage.setItem(userId + "record", JSON.stringify(recordData))
}

// 修改某次测评的上一题答案
export function deleteLastQuestionCache (userId, gaugeId, taskId) {
  let data = getGaugeEvaluationRecord(userId, gaugeId, taskId) // 获取本地答案缓存--100%存在
  if (!data || !data.recordList) {
    return
  }
  data.recordList.splice(-1, 1)
  let recordData  // 查询是否有保存记录

  recordData = window.localStorage.getItem(userId + "record")
  recordData = JSON.parse(recordData)
  if (taskId) {
    recordData[taskId][gaugeId] = data
  } else {
    recordData[gaugeId] = data
  }

  window.localStorage.setItem(userId + "record", JSON.stringify(recordData))
}

/**
 * 获取本地存储的量表答题记录及答题时间
 */
export function getGaugeEvaluationRecord (userId, gaugeId, taskId) {
  let allData

  allData = window.localStorage.getItem(userId + "record")
  if (!allData) {
    return null
  } else if (taskId) { // 存在任务id
    allData = JSON.parse(allData)
    return allData[taskId] && allData[taskId][gaugeId]
  } else if (gaugeId) { // 普通量表
    allData = JSON.parse(allData)
    return allData[gaugeId]
  }
}


// 清空普通量表的答题记录及答题时间--再测一次的时候使用
export function clearGaugeEvaluationRecord (userId, gaugeId, taskId) {
  let allData

  allData = window.localStorage.getItem(userId + "record")
  if (allData) {
    allData = JSON.parse(allData)
    if (!taskId) {
      allData[gaugeId] = null
    } else {
      allData[taskId][gaugeId] = null
    }


    window.localStorage.setItem(userId + "record", JSON.stringify(allData))
  }
}

// 量表报告缓存
export function saveGaugeReportCache (data) {

  window.sessionStorage.setItem("gaugeReportCache", JSON.stringify(data))
}

// 获取量表报告
export function getGaugeReportCache () {
  let data;

  data = window.sessionStorage.getItem("gaugeReportCache")
  return data && JSON.parse(data)
}


// 保存工具包的缓存
export function saveToolsItem (toolsKey, data) {
  let toolsList

  toolsList = window.localStorage.getItem("toolsList")
  if (!toolsList) {
    toolsList = {}
  } else {
    toolsList = JSON.parse(toolsList)
  }
  toolsList[toolsKey] = data

  window.localStorage.setItem("toolsList", JSON.stringify(toolsList))
}

// 获取工具包详情--缓存
export function getToolsItemBycache (toolsKey) {
  let toolsList

  toolsList = window.localStorage.getItem("toolsList")
  if (toolsList) {
    toolsList = JSON.parse(toolsList)
    return toolsList[toolsKey]
  } else {
    return null
  }
}

// 计算日期的方法
function getDay (day) {
  var today = new Date();
  var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
  today.setTime(targetday_milliseconds);
  var tYear = today.getFullYear();
  var tMonth = today.getMonth();
  var tDate = today.getDate();
  tMonth = doHandleMonth(tMonth + 1);
  tDate = doHandleMonth(tDate);
  return tYear + "/" + tMonth + "/" + tDate; //月日
}
function doHandleMonth (month) {
  var m = month;
  if (month.toString().length == 1) {
    m = "0" + month;
  }
  return m;
}

function dsdd (e) {  //拼接
  let dataArr = []
  dataArr.splice(0);//请控之前的数据
  for (let i = 0; i < e; i++) {
    dataArr.push(getDay(-i));//-i 代表之前  i代表将来
  }
  return dataArr.reverse()
}

export function setSevenDay (e) {
  return dsdd(e)
}